export const toastrSettings = {
  toastrErrorDuplicateExpirationMs: 61000,
  toastrTimeOutMs: 3500,
};
